import React, { useEffect, createElement } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { CalculatorFlow } from './pages/CalculatorFlow';
import { CalculatorFlowSummer } from './pages/CalculatorFlowSummer';
import { RetentionBreakdown } from './pages/RetentionBreakdown';
import { RetentionBreakdownSummer } from './pages/RetentionBreakdownSummer';
import { ContactGate } from './pages/ContactGate';
import { ContactGateSummer } from './pages/ContactGateSummer';
import { ResultsPage } from './pages/ResultsPage';
import { ResultsPageSummer } from './pages/ResultsPageSummer';
import { PreviewEditor } from './pages/PreviewEditor';
import { RSVPForm } from './pages/RSVPForm';
function App() {
  useEffect(() => {
    // Meta Pixel Code - only initialize once
    if ((window as any).fbq) return; // Prevent double initialization
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      if (s && s.parentNode) {
        s.parentNode.insertBefore(t, s);
      } else {
        b.head.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '5482618825296943');
    (window as any).fbq('track', 'PageView');
  }, []);
  return <BrowserRouter data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<LandingPage data-id="element-3" />} data-id="element-2" />

        {/* Year-Round Program Routes */}
        <Route path="/calculator" element={<CalculatorFlow data-id="element-5" />} data-id="element-4" />
        <Route path="/retention" element={<RetentionBreakdown data-id="element-7" />} data-id="element-6" />
        <Route path="/contact" element={<ContactGate data-id="element-9" />} data-id="element-8" />
        <Route path="/results" element={<ResultsPage data-id="element-11" />} data-id="element-10" />

        {/* Summer Program Routes */}
        <Route path="/calculator-summer" element={<CalculatorFlowSummer data-id="element-13" />} data-id="element-12" />
        <Route path="/retention-summer" element={<RetentionBreakdownSummer data-id="element-15" />} data-id="element-14" />
        <Route path="/contact-summer" element={<ContactGateSummer data-id="element-17" />} data-id="element-16" />
        <Route path="/results-summer" element={<ResultsPageSummer data-id="element-19" />} data-id="element-18" />

        {/* Other Routes */}
        <Route path="/preview" element={<PreviewEditor data-id="element-21" />} data-id="element-20" />
        <Route path="/rsvp" element={<RSVPForm data-id="element-23" />} data-id="element-22" />

        {/* Redirect old route to new landing */}
        <Route path="*" element={<Navigate to="/" replace data-id="element-25" />} data-id="element-24" />
      </Routes>
    </BrowserRouter>;
}
export { App };